module.exports = __webpack_public_path__ + "img/description.6a5bc0ab.png";